export default {
  common: {
    save: '保存',
    cancel: '取消',
    delete: '删除',
    edit: '编辑',
    create: '新建',
    upload: '上传',
    loading: '加载中...',
    success: '成功',
    error: '错误',
    confirm: '确认',
    back: '返回',
    zh: '中文',
    en: '英文'
  },
  document: {
    title: '标题',
    titleEng: '英文标题',
    type: '类型',
    author: '作者',
    content: '内容',
    contentEng: '英文内容',
    sortDate: '内容日期',
    publishDate: '发布日期',
    attachmentSection: '附件',
    thumbnail: '缩略图',
    documentTypes: {
      confidentialFile: '机密文件',
      courtVerdict: '法庭审判书',
      backgroundStory: '背后故事'
    },
    form: {
      newDocument: '新建文档',
      editDocument: '编辑文档',
      titleRequired: '请输入标题',
      titleEngRequired: '请输入英文标题',
      typeRequired: '请选择文档类型',
      contentRequired: '请输入内容',
      contentEngRequired: '请输入英文内容',
      sortDateRequired: '请选择内容日期',
      selectFile: '选择文件',
      fileTooLarge: '文件大小不能超过100MB',
      uploadAttachment: '上传附件',
      selectThumbnail: '选择缩略图',
      thumbnailTooLarge: '缩略图大小不能超过5MB',
      invalidImageType: '只支持JPG、PNG和GIF格式的图片',
      removeThumbnail: '删除缩略图',
      thumbnailUploadSuccess: '缩略图上传成功',
      thumbnailUploadError: '缩略图上传失败',
      thumbnailDeleteSuccess: '缩略图删除成功',
      thumbnailDeleteError: '缩略图删除失败'
    },
    list: {
      noDocuments: '暂无文档',
      search: '搜索文档...',
      filter: '筛选',
      sort: '排序'
    },
    tabs: {
      content: '文档内容',
      attachments: '附件'
    },
    attachments: {
      clickToView: '点击任意附件项可查看详情',
      uploadedAt: '上传于',
      view: '查看附件',
      backToList: '返回附件列表',
      unsupportedType: {
        title: '无法预览此文件类型',
        message: '请下载后查看'
      }
    },
    actions: {
      back: '返回',
      backToHome: '返回首页'
    },
    error: {
      notFound: {
        title: '文档未找到',
        message: '抱歉，您请求的文档不存在或已被删除。'
      }
    },
    date: {
      unknown: '未知日期'
    },
    types: {
      confidentialFile: '机密文件',
      courtVerdict: '法庭审判书',
      backgroundStory: '背后故事',
      unknown: '未知类型'
    }
  },
  auth: {
    login: '登录',
    logout: '退出登录',
    username: '用户名',
    password: '密码',
    loginSuccess: '登录成功',
    loginError: '登录失败',
    logoutSuccess: '已退出登录'
  },
  nav: {
    home: '首页',
    documents: '文档',
    admin: '管理',
    settings: '设置'
  },
  home: {
    title: '清算中共.档案馆',
    subtitle: '保存历史真相，铭记历史教训',
    description: '',
    aboutUs: {
      title: '关于我们',
      content: '本档案馆所有资料均来源于公开渠道或历史文献，经过严格考证。我们坚持客观、公正的原则，让历史事实自己说话。'
    },
    quickLinks: {
      title: '快速链接',
      home: '首页',
      confidential: '机密文件',
      verdicts: '法庭审判书',
      stories: '背后故事',
      admin: '管理'
    },
    footer: {
      copyright: '© {year} 清算中共.档案馆 - 保存历史真相',
      closeMenu: '关闭菜单'
    },
    navigation: {
      login: '登录',
      logout: '登出'
    },
    hero: {
      title: '清算中共.档案馆',
      subtitle: '保存历史真相，铭记历史教训',
      classification: '绝密档案'
    },
    mission: {
      title: '档案馆宗旨',
      content: '清算中共.档案馆致力于收集、整理和保存有关中国共产党历史罪行的文献资料，包括机密文件、法庭审判书和历史事件的背后故事。我们的使命是通过保存这些历史记录，确保历史真相不被篡改或遗忘，为后人提供学习历史教训的机会。\n\n本档案馆所有资料均来源于公开渠道或历史文献，经过严格考证。我们坚持客观、公正的原则，让历史事实自己说话。'
    },
    categories: {
      title: '档案分类',
      confidential: {
        title: '机密文件',
        description: '中共内部机密文件，揭露其真实面目和罪行。这些文件展示了中共在公开场合与内部决策的巨大差异。',
        button: '查看文件'
      },
      verdicts: {
        title: '法庭审判书',
        description: '对中共及其官员的法庭审判记录和判决书，记录了司法程序中确认的历史罪行和相关证据。',
        button: '查看审判书'
      },
      stories: {
        title: '背后故事',
        description: '揭露中共罪行背后的真相和历史事件，通过详实的调查和研究，还原历史真相。',
        button: '查看故事'
      }
    },
    quote: {
      text: '历史不会忘记，人民不会忘记。只有铭记历史，才能避免重蹈覆辙。',
      author: '清算中共.档案馆'
    }
  },
  confidential: {
    title: '机密文件',
    description: '这里收集了中共内部机密文件，揭露其真实面目和罪行',
    search: {
      placeholder: '搜索标题'
    },
    noDocuments: '没有找到相关文档',
    document: {
      attachments: '个附件',
      readMore: '阅读全文',
      unknownDate: '未知日期',
      noSummary: '暂无摘要'
    }
  },
  verdicts: {
    title: '法庭审判书',
    description: '这里收集了对中共及其官员的法庭审判记录和判决书',
    search: {
      placeholder: '搜索标题'
    },
    noDocuments: '没有找到相关文档',
    document: {
      attachments: '个附件',
      readMore: '阅读全文',
      unknownDate: '未知日期',
      noSummary: '暂无摘要'
    }
  },
  stories: {
    title: '背后故事',
    description: '这里收集了揭露中共罪行背后的真相和历史事件',
    search: {
      placeholder: '搜索标题'
    },
    noDocuments: '没有找到相关文档',
    document: {
      attachments: '个附件',
      readMore: '阅读全文',
      unknownDate: '未知日期',
      noSummary: '暂无摘要'
    }
  }
} 